import classNames from 'classnames'
import React, { useEffect, useState } from 'react'
import Icon from 'meinian-package/src/component/icon'
import Button from 'meinian-package/src/baseComponent/button'
import { All, Item, Start, Stop, Num, AllButton, getBatchSelected, answer } from './base'
import './index.less'

export const BatchItem = (props) => {
  const { className, ...otherProps } = props
  return <Item className={classNames('meinian-batch-check', className)} {...otherProps} />
}

export const BatchAll = (props) => {
  return <All className="meinian-batch-check-all" {...props} />
}

export const BatchAllButton = (props) => {
  const { keyValues = [] } = props
  const [selected, setSelected] = useState(getBatchSelected())
  useEffect(() => { answer(setSelected) }, [])

  return <AllButton className="meinian-select-all-button" {...props} selected={selected}>
    <Button type="normal" className="meinian-select-button">{!keyValues.every(m => selected.has(m)) ? '全选' : '取消全选'}</Button>
  </AllButton>
}

export const BatchStart = ({ displayTextClassName = null, ...props }) => {
  return <Start className={classNames('meinian-batch-start', displayTextClassName)} {...props}>
    <Icon type="m-piliangcaozuo" style={{ marginRight: 4, fontSize: 16 }} />批量操作
  </Start>
}

export const BatchStop = (props) => {
  return <Stop className="meinian-batch-stop" {...props}>
    <Button type="normal">取消</Button>
  </Stop>
}
BatchStop.Green = (props) => {
  return <Stop className="meinian-batch-stop-green" {...props}>
    <Button type="primary" style={{ width: '80px', height: '28px', paddingTop: '5px' }}>完成</Button>
  </Stop>
}
export const BatchNum = (props) => {
  return <Num className="meinian-batch-num" {...props} />
}
